import { IRepo } from "./Storage/IRepo";
import { RawSpecteamShopContent } from "../Models/ProductsCatalog/RawSpecteamShopContent";


export class SpecteamShopContentProvider
{
    private cachedContent: RawSpecteamShopContent | null = null;

    constructor(private _repo: IRepo<RawSpecteamShopContent>)
    { }

    public async Get(): Promise<RawSpecteamShopContent>
    {
        if (this.cachedContent)
        {
            return this.cachedContent;
        }

        const raw = await this._repo.GetOne("", "WebsiteContent");

        if (!raw)
        {
            throw new Error(`Could not get shop content`);
        }

        this.cachedContent = raw;

        return this.cachedContent;
    }
}
